// import React from 'react';
// import {
//     Dialog,
//     DialogTitle,
//     DialogContent,
//     IconButton,
//     Typography,
//     Grid,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Paper,
//     Box,
//     Divider,
// } from '@mui/material';
// import { MdCancel } from "react-icons/md";
// import "../../OperatorRegistration/Modal/TableDataViewModal.css";
// import documentImage from "../../../Assets/Emirates_ID_Card_For_UAE_Citizens_(New).png"

// const TableDataViewModal = ({ open, onClose, modalViewHeadingName, notModalTable }) => {
//     const purchaser = {
//         firstName: 'Mani',
//         lastName: 'Krish',
//         email: 'manikrish@gmail.com',
//         mobileNumber: '9823281781',
//         userType: 'Individual',
//         documentType: 'Emirates ID',
//         addressLine1: 'CL-720',
//         addressLine2: 'Afza, Ajman',
//         city: 'Al Ain',
//         state: 'Abu Dhabi',
//         country: 'United Arab Emirates',
//         zipcode: '20000',
//         schemes: [
//             {
//                 name: 'Scheme 1',
//                 purchaseValue: '$1000',
//                 goldValue: '13.8 g',
//                 purchaseDate: '15 Jan 2025',
//                 maturityDate: '15 Jan 2027',
//             },
//         ],
//     };
//     const TableHeadModalData = ["Scheme Name", "Purchase Value", "Gold Value", 'Purchase Date', "Maturity Date"]

//     const Documents = [documentImage, documentImage, documentImage]

//     return (
//         <Dialog
//             open={open}
//             onClose={onClose}
//             fullWidth
//             maxWidth="md"
//             className="custom-dialog"
//             sx={{
//                 "& .MuiPaper-root": {
//                     borderRadius: "14px",
//                 },
//             }}
//         >
//             <Box sx={{ position: 'relative' }}>
//                 {/* Dialog Header */}
//                 <Box className="dialog-heading">
//                     <IconButton
//                         aria-label="Close"
//                         onClick={onClose}
//                         sx={{
//                             position: 'absolute',
//                             top: 8,
//                             right: 8,
//                             color: 'text.secondary',
//                         }}
//                     >
//                         <MdCancel />
//                     </IconButton>
//                     <DialogTitle className="custom-dialog-title">
//                         <Typography className="custom-title-text" color="white">
//                             {modalViewHeadingName}
//                         </Typography>
//                     </DialogTitle>
//                 </Box>
//             </Box>

//             <DialogContent>
//                 <Box p={{ xs: 2, md: 1 }}>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
//                         {/* Aligning using flex and justifyContent */}

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     First Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.firstName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Last Name
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.lastName}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     User Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.userType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Email
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.email}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Mobile Number
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.mobileNumber}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Document Type
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.documentType}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 1
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine1}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Address Line 2
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.addressLine2}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     City
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.city}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>
//                     <Grid sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>

//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     State
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.state}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     country
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.country}</Typography>
//                             </Box>
//                         </Grid>
//                         <Grid item  >
//                             <Box className="content-layout">
//                                 <Typography variant="body1" className="tabledataview-content-textheading">
//                                     Zipcode
//                                 </Typography>
//                                 <Typography variant="subtitle2">{purchaser.zipcode}</Typography>
//                             </Box>
//                         </Grid>
//                     </Grid>

//                     <Divider sx={{ mt: 3 }} />

//                     {/* Schemes Table */}
//                     {!notModalTable && (
//                         <>
//                             <Box mt={4}>
//                                 <Typography variant="body2" gutterBottom>
//                                     Schemes Purchased
//                                 </Typography>
//                                 <TableContainer component={Paper} sx={{ boxShadow: "none" }}>
//                                     <Table sx={{ borderCollapse: 'collapse' }}>
//                                         <TableHead>
//                                             <TableRow sx={{ p: "16px 0" }}>
//                                                 {TableHeadModalData.map((data, index) => (

//                                                     <TableCell sx={{
//                                                         color: "#7A7A7A", border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                         textOverflow: 'ellipsis',
//                                                     }}>
//                                                         <Typography variant='body1'> {data}</Typography></TableCell>
//                                                 ))}
//                                             </TableRow>
//                                         </TableHead>

//                                         <TableBody>
//                                             {purchaser.schemes.map((scheme, index) => (
//                                                 <TableRow key={index}>
//                                                     {Object.keys(scheme).map((key) => (
//                                                         <TableCell key={key} sx={{
//                                                             border: "none", p: "10px 10px 0 0px", whiteSpace: 'nowrap',
//                                                             textOverflow: 'ellipsis',
//                                                         }} >
//                                                             <Typography variant='subtitle2'>
//                                                                 {scheme[key]}
//                                                             </Typography>
//                                                         </TableCell>
//                                                     ))}
//                                                 </TableRow>
//                                             ))}
//                                         </TableBody>

//                                     </Table>
//                                 </TableContainer>
//                             </Box>
//                             <Divider sx={{ mt: 3 }} />

//                         </>
//                     )}

//                     <Grid xs={12} mt={1}>
//                         <Typography variant="body2">
//                             Documents
//                         </Typography>
//                         <Grid container spacing={2} mt={1}>
//                             {Documents.map((data, index) => (
//                                 <Grid item xs={12} md={4} key={index}>
//                                     <Box sx={{ p: 1, background: "white", boxShadow: 2, borderRadius: "5px" }}>
//                                         <Box
//                                             component="img"
//                                             src={data}
//                                             height="200px"
//                                             width="100%"
//                                             display="block"
//                                             margin="0" // Center the image within the grid cell
//                                         />
//                                     </Box>
//                                 </Grid>
//                             ))}
//                         </Grid>
//                     </Grid>

//                 </Box>
//             </DialogContent>
//         </Dialog >
//     );
// };

// export default TableDataViewModal;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Divider,
  Button,
  Stack,
  Grid2,
} from "@mui/material";
import { MdCancel } from "react-icons/md";
import "../../../../../Components/ModalCss/TableDataViewModal.css"
import SchemeCardApproval from "../../../../../Components/SchemeCard/SchemeCardApproval";
import RejectCommendModal from "./RejectCommendModal";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../ReduxStore/actions";
import { format } from "date-fns";
import cardImage from "../../../../../Assets/login_bgImage.png";
import { clearTableGetId } from "../../../../../ReduxStore/Slices/TableId/TableIdGetSlice";
import { clearCustomerId } from "../../../../../ReduxStore/Slices/Operator/customerSlice";
import { toast } from "react-toastify";


const PurchaseApprovalModalView = ({
  open,
  onClose,
  modalViewHeadingName,
  IsShowRejectApproveButton,
  isRejectTextShowModal
}) => {
  console.log(IsShowRejectApproveButton, "fsfjdshfjsdk")
  const scheme = {
    title: "Scheme 1",
    valueofPurchase: "$1000",
    purchaseStake: "13.8 grams",

    maturity: "24 Months",
    lockIn: "24 Months",
    reapBenifits: "6% Every 3 Months",
    closureDate: "15/11/2025",
    Description:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley",
  };



  const TableId = useSelector((state) => state.Table.TableId);
  console.log(TableId, "tableIddddddd")
  // const [isWarningModalOpen, setWarningModalOpen] = useState(false);

  const { getPlanById } = useSelector((state) => state?.getPlanById);

  const [schemeCardData, setSchemeCardData] = useState(
    {
      title: "Scheme Name 1",
      valueOfPurchase: "1000",
      purchase: "13.8",
      maturity: "24",
      lockIn: "24",
      reap_months: "3",
      benefit: "6",
      closingDate: "15/Mar/2025",
      backgroundImage: "gold-card-1", // replace with the background image URL
      firstButtonText: "Add to Cart",
      secondButtonText: "Buy Now",
      image_url: cardImage,
    }
  )
  const [schemeData, setSchemeData] = useState(
    {
      title: "--",
      valueofPurchase: "--",
      purchaseStake: "--",

      maturity: "--",
      lockIn: "--",
      reapBenifits: "--",
      closureDate: "--",
      Description:
        "--",
    }
  )



  // {
  //   title: "Scheme 1",
  //   valueofPurchase: "$1000",
  //   purchaseStake: "13.8 grams",

  //   maturity: "24 Months",
  //   lockIn: "24 Months",
  //   reapBenifits: "6% Every 3 Months",
  //   closureDate: "15/11/2025",
  //   Description:
  //     "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley",
  // }

  console.log(schemeData, "schemeDataschemeDataschemeData")
  const dispatch = useDispatch()
  // useEffect(() => {
  //   if (!open) return; // Only fetch when modal is open
  //   console.log("itssssssss")
  //   if (TableId) {
  //     const fetchData = async () => {
  //       try {

  //         const data1 = {
  //           data: {},
  //           method: "get",
  //           apiName: `getPlanById/${TableId}`,
  //         };
  //         const responseData = await dispatch(actions.GETPLANBYID(data1));
  //         setSchemeData(responseData)
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     }
  //     fetchData();
  //   }

  // }, [dispatch, open,schemeData,TableId]);


  useEffect(() => {
    console.log(TableId, "itssssssss")
    if (TableId) {
      console.log("itssssssssworkk")

      const fetchData = async () => {
        try {
          const data1 = {
            data: {},
            method: "get",
            apiName: `getPlanById/${TableId}`,
          };
          const responseData = await dispatch(actions.GETPLANBYID(data1));
          // setSchemeData(responseData)

        } catch (error) {
          console.error("Error fetching data:", error);
        }
      }
      fetchData();
    }
  }, [dispatch, open]);

  console.log(schemeData?.payload?.data?.title, "schemeeeedata")


  useEffect(() => {
    if (!open || !TableId) return; // Prevents unnecessary calls when modal is closed

    let isMounted = true; // Flag to check if the component is still mounted
    const fetchData = async () => {
      try {
        const data1 = {
          data: {},
          method: "get",
          apiName: `getPlanById/${TableId}`,
        };
        const responseData = await dispatch(actions.GETPLANBYID(data1));

        if (isMounted) {
          setSchemeData({
            title: responseData?.payload?.data?.title || "Scheme 1",
            plan_id: responseData?.payload?.data?.plan_id,
            valueOfPurchase: `$ ${responseData?.payload?.data?.value_of_purchase || "1000"}`,
            purchaseStake: `${responseData?.payload?.data?.purchase_stake || "13.8"} grams`,
            maturity: `${responseData?.payload?.data?.maturity_in_months || "24"} Months`,
            lockIn: `${responseData?.payload?.data?.lock_in_months || "24"} Months`,
            reapBenifits: `${responseData?.payload?.data?.reap_percentage || "6"}% Every ${responseData?.payload?.data?.reap_months || "3"} Months`,
            closureDate: responseData?.payload?.data?.closure_date
              ? format(new Date(responseData.payload.data.closure_date), 'MMMM d, yyyy')
              : "15/11/2025",
            Description: responseData?.payload?.data?.description ||
              "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
          });

          setSchemeCardData({
            title: responseData?.payload?.data?.title,
            valueOfPurchase: responseData?.payload?.data?.value_of_purchase,
            purchase: responseData?.payload?.data?.purchase_stake,
            maturity: responseData?.payload?.data?.maturity_in_months,
            lockIn: responseData?.payload?.data?.lock_in_months,
            reap_months: responseData?.payload?.data?.reap_months,
            benefit: responseData?.payload?.data?.reap_percentage,
            closingDate: responseData?.payload?.data?.closure_date
              ? format(new Date(responseData.payload.data.closure_date), 'MMMM d, yyyy')
              : "15/11/2025",
            firstButtonText: responseData?.payload?.data?.primary_button_text,
            secondButtonText: responseData?.payload?.data?.secondary_button_text,
            image_url: responseData?.payload?.data?.image_url,
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();

    return () => {
      isMounted = false; // Prevents state updates if the modal is closed
    };
  }, [dispatch, open, TableId]);

  //   useEffect(() => {
  //     if (schemeData?.payload?.data) {
  // console.log("hdsfhshjs")
  //       setSchemeData({
  //         title: schemeData?.payload?.data?.title,
  //         valueofPurchase: `USD ${schemeData?.payload?.data?.value_of_purchase}`,
  //         purchaseStake: `${schemeData?.payload?.data?.purchase_stake} grams`,

  //         maturity: `${schemeData?.payload?.data?.maturity_in_months} Months`,
  //         lockIn: `${schemeData?.payload?.data?.lock_in_months} Months`,
  //         reapBenifits: `${schemeData?.payload?.data?.reap_percentage}% Every ${schemeData?.payload?.data?.reap_months} Months`,
  //         closureDate: format(new Date(schemeData?.payload?.data?.closure_date), 'MMMM d, yyyy') ,
  //         Description:
  //           schemeData?.payload?.data?.description
  //       })

  //     } else {
  //       setSchemeData({
  //         title: "Scheme 1",
  //         valueofPurchase: "$1000",
  //         purchaseStake: "13.8 grams",

  //         maturity: "24 Months",
  //         lockIn: "24 Months",
  //         reapBenifits: "6% Every 3 Months",
  //         closureDate: "15/11/2025",
  //         Description:
  //           "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever since the 1500s, when an unknown printer took a galley",

  //       })

  //     }

  //   }, [open]);




  const [isRejectCommendModalopen, setRejectCommendModalopen] = useState(false);

  const handleRejectCommendOpenModal = () => {
    setRejectCommendModalopen(true);
  };

  const handleRejectCommendCloseModal = () => {
    setRejectCommendModalopen(false);
    dispatch(clearTableGetId(null))
    dispatch(clearCustomerId(null))
  };


  const { approvePlan } = useSelector((state) => state?.approvePlan);

  const SchemeApprove = async (id) => {

    console.log(id, "hiiiiiiiiiiiiiiiiiiiiii")

    const data1 = { data: {}, method: "put", apiName: `approvePlan/${id}` };
    const approveResponse = await dispatch(actions.APPROVEPLAN(data1));

    console.log(approveResponse.payload.message, "approveResponse");

    if (approveResponse.payload.message === "Plan approved successfully.") {

      toast.success("Approved Successfully.")
      setTimeout(() => onClose(), 1500)
      dispatch(clearTableGetId(null))
      dispatch(clearCustomerId(null))


    }

    if (approveResponse.payload.message === "This plan is already approved.") {

      toast.error("This plan is already approved.")
      setTimeout(() => onClose(), 1500)
    }


  }






  const TableHeadModalData = [
    "Scheme Name",
    "Purchase Value",
    "Gold Value",
    "Purchase Date",
    "Maturity Date",
  ];
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      className="custom-dialog"
      sx={{
        "& .MuiPaper-root": {
          // maxWidth:"700px",
          borderRadius: "14px",
        },
      }}
    >
      <Box sx={{ position: "relative" }}>
        {/* Dialog Header */}
        <Box className="dialog-heading">
          <IconButton
            aria-label="Close"
            onClick={() => {
              onClose()
              dispatch(clearTableGetId(null))
              dispatch(clearCustomerId(null))

            }}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "text.secondary",
            }}
          >
            <MdCancel />
          </IconButton>
          <DialogTitle className="custom-dialog-title">
            <Typography className="custom-title-text" color="white">
              {modalViewHeadingName}
            </Typography>
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent>
        <Box
        // p={{ xs: 2, md: 3 }}
        >
          {/* <Grid container spacing={2}>
           
            {[
              { label: "Title", value: scheme.title },
              { label: "Value of Purchase", value: scheme.valueofPurchase },
              { label: "Purchase Stake", value: scheme.purchaseStake },
              { label: "Maturity", value: scheme.maturity },
              { label: "Lock In", value: scheme.lockIn },
              { label: "Reap Benifits", value: scheme.reapBenifits },
              { label: "Description", value: scheme.Description },
              { label: "Closure Date", value: scheme.closureDate },
            ].map((field, index) => (
              // <Grid item xs={12} sm={4} md={4} key={index} width="100%">

              //   <Box
              //     display="flex"
              //     flexDirection="column"
              //     justifyContent="space-between"
              //   >

              <Grid
                item
                xs={12}
                sm={4}
                md={field.label === "Description" ? 8 : 4}
                key={index}
                sx={{
                  display: "flex",
                  

                  justifyContent:
                    index % 3 === 0
                      ? "flex-start"
                      : index % 3 === 1
                      ? "center"
                      : "flex-end",
                  textAlign:
                    index % 3 === 0
                      ? "start"
                      : index % 3 === 1
                      ? "start"
                      : "start",
                }}
              >
                <Grid
                  // item
                  // xs={12}
                  // sm={4}
                  // md={field.label==="Description"? 8 : 4}

                  // key={index}
                  sx={{
                    width: "100%",
                    display: "flex",
                    alignItems: "start",
                    justifyContent:
                      index % 3 === 0
                        ? "flex-start"
                        : index % 3 === 1
                        ? "center"
                        : "flex-end",
                    textAlign:
                      index % 3 === 0
                        ? "start"
                        : index % 3 === 1
                        ? "start"
                        : "start",
                  }}
                >
                  <Grid sx={{ width: "100%" }}>
                    <Box
                      display="flex"
                      flexDirection="column"
                      justifyContent="start"
                      textAlign="start"
                    >
                      <Typography
                        variant="body1"
                        className="tabledataview-content-textheading"
                      >
                        {field.label}
                      </Typography>
                      <Typography variant="subtitle2">{field.value}</Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Grid> */}
          <Grid container spacing={2}>
            {[
              { label: "Title", value: schemeData.title },
              { label: "Value of Purchase", value: schemeData.valueOfPurchase },
              { label: "Purchase Stake", value: schemeData.purchaseStake },
              { label: "Maturity", value: schemeData.maturity },
              { label: "Lock In", value: schemeData.lockIn },
              { label: "Reap Benefits", value: schemeData.reapBenifits },
              { label: "Description", value: schemeData.Description },
              { label: "Closure Date", value: schemeData.closureDate },
            ].map((field, index) => (
              <Grid
                item
                xs={field.label === "Description" ? 12 : 6}
                sm={4}
                md={field.label === "Description" ? 8 : 4}
                key={index}
              >
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                  textAlign="start"
                  sx={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  <Typography
                    variant="body1"
                    className="tabledataview-content-textheading"
                  >
                    {field.label}
                  </Typography>
                  <Typography variant="subtitle2">{field.value}</Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ mt: 3 }} />
          <SchemeCardApproval scheme={schemeCardData} />

          {isRejectTextShowModal && (
            <Box>
              <Typography
                variant="subtitle2"

              >
                Reject Commend:
              </Typography>

              <Typography variant="body1" sx={{ color: "gray", mt: 1 }}>
                {/* "Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry’s standard dummy text
                ever since the 1500s, when an unknown printer took a galley", */}

                {getPlanById?.data?.reject_comment}
              </Typography>
            </Box>
          )}
          {/* reject comamd */}
          {/* Schemes Table */}

          {IsShowRejectApproveButton && (
            <>
              <Divider sx={{ mt: 3 }} />
              <Grid mt={1} sx={{ display: "flex", justifyContent: "end" }}>
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    onClick={handleRejectCommendOpenModal}
                    className="reject-button"
                    sx={{
                      // backgroundColor: "#C38F51",
                      textTransform: "none",
                      color: "#F53E5C",
                      fontSize: "16px",
                      // padding: "0px 40px",
                      padding: { xs: "0px 20px", md: "0px 40px" },

                      minHeight: "40px",
                      borderRadius: "23px",
                      boxShadow: "none",
                      border: "1px solid #F53E5C",
                      background: "white 0% 0% no-repeat padding-box",
                      // "&:hover": {
                      //     backgroundColor: "#3B4056",
                      // },
                    }}
                  >
                    {/* {bannerDates?.[0]?.additional_data?.[0]?.primary_button_text || "Primary Button"} */}
                    Reject
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      SchemeApprove(schemeData.plan_id);
                    }}
                    sx={{
                      // backgroundColor: "#FFAA17",b
                      border: "1px solid #1FC45B",
                      textTransform: "none",
                      boxShadow: "none",
                      color: "white",
                      fontSize: "16px",
                      padding: { xs: "0px 20px", md: "0px 40px" },
                      minHeight: "40px",
                      borderRadius: "23px",
                      // font: "normal normal normal 16px / 25px Roboto",
                      letterSpacing: "0px",
                      color: "white",
                      background: "#1FC45B",
                      // "&:hover": {
                      //     backgroundColor: "#C38F51",
                      // },
                    }}
                  >
                    {/* {bannerDates?.[0]?.additional_data?.[0]?.secondary_button_text || "Secondary Button"} */}
                    Approve
                  </Button>
                </Stack>
              </Grid>
            </>
          )}
        </Box>
      </DialogContent>
      <RejectCommendModal
        open={isRejectCommendModalopen}
        onClose={handleRejectCommendCloseModal}
        onSchemeApprovalModalClose={onClose}
      />
    </Dialog>
  );
};

export default PurchaseApprovalModalView;
